import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';

/** fetchRegistrationReceivedList  */
interface IDataItems {
  registration_received_id: number;
  msid_country: string;
  message_id: string;
  message_timestamp: string;
  application_type: string;
  vat_number: string;
  company_name: string;
  change_date: string;
  address_free: string;
  address_country: string;
  telephone: string;
  email: string;
  websites: string;
  contact_title: string;
  contact_first_name: string;
  contact_last_name: string;
  trading_names: string;
  country_of_business: string;
  vat_group: number;
  bank_iban: string;
  bank_account: string;
  bank_bic: string;
  request_date: string;
  commencement_date: string;
  registration_date: string;
  created_by: string;
  created_at: string;
  modified_by: string;
  modified_at: string;
  incoming_message_id: number;
}

interface IPaging {
  page: string;
  pageSize: string;
  total: number;
}

interface IRegistrationReceivedListOutput {
  items: IDataItems[];
  paging: IPaging;
}

interface IRegistrationReceivedListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  vat_num?: string;
  msidCountry?: string;
  schemeType?: string;
}

export const fetchRegistrationReceivedList = async (
  payload: IRegistrationReceivedListInput
): Promise<Types.ResponseOutput> => {
  let searchQuery = '';
  if (payload.vat_num) searchQuery += `&vat_num=${payload.vat_num}`;
  if (payload.msidCountry) {
    searchQuery += `&msidCountry=${payload.msidCountry}`;
  }
  if (payload.schemeType) searchQuery += `&schemeType=${payload.schemeType}`;
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/registration-received/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}${searchQuery}`
  );

  let _data: IRegistrationReceivedListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};

/** RegistrationReceived Detail */
interface IRegistrationReceivedDetailInput {
  registration_received_id: number;
}

interface IRegistrationReceivedDetailOutput extends Types.ResponseOutput {
  data: {
    registration_received_id: number | null;
    msid_country: string;
    message_id: string;
    message_timestamp: string;
    application_type: string;
    vat_number: string;
    company_name: string;
    change_date: string;
    address_free: string;
    address_country: string;
    telephone: string;
    email: string;
    websites: string;
    trading_names: string;
    country_of_business: string;
    vat_group: boolean;
    bank_iban: string;
    bank_account: string;
    bank_bic: string;
    request_date: string;
    commencement_date: string;
    registration_date: string;
    incoming_message_id: number | null;
    vat_number_int: string;
    not_established: boolean;
    electronic_interface: boolean;
    other_msnetp: boolean;
    previous_registrations: boolean;
    contact_name_free: string;
    created_at: string;
  };
}

export const fetchRegistrationReceivedDetail = async (
  payload: IRegistrationReceivedDetailInput
): Promise<IRegistrationReceivedDetailOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/registration-received/${payload.registration_received_id}`
  );

  let output = {
    message: data.message,
    data: data.data,
    status: data.status,
  };
  return output;
};

/** fetchFixedEstablishmentReceivedList  */
interface IFixedEstablishmentReceivedListOutput {
  items: IFEReceivedDataItems[];
  paging: IPaging;
}

interface IFEReceivedDataItems {
  fixed_establishment_received_id: number;
  registration_received_id: number;
  fe_country: string;
  fe_vat_number: string;
  fe_trading_name: string;
  fe_address: string;
  fe_address_country: string;
}

interface IFixedEstablishmentReceivedListInput {
  sortField: string;
  page: number;
  pageSize: number;
  order: 'asc' | 'desc';
  id: number;
}

export const fetchFixedEstablishmentReceivedList = async (
  payload: IFixedEstablishmentReceivedListInput
): Promise<Types.ResponseOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/registration-received/${payload.id}/fixed-establishments/list?page=${payload.page}&pageSize=${payload.pageSize}&sortField=${payload.sortField}&order=${payload.order}`
  );

  let _data: IFixedEstablishmentReceivedListOutput = data.data;
  let output: Types.ResponseOutput = {
    message: data.message,
    data: _data,
    status: data.status,
  };
  return output;
};
